import { render, staticRenderFns } from "./quote-view.vue?vue&type=template&id=a4f898b6&scoped=true&"
import script from "./quote-view.vue?vue&type=script&lang=js&"
export * from "./quote-view.vue?vue&type=script&lang=js&"
import style0 from "./quote-view.vue?vue&type=style&index=0&id=a4f898b6&lang=scss&scoped=true&"
import style1 from "./quote-view.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f898b6",
  null
  
)

export default component.exports